/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import useOpportunityService from 'domain/sales/opportunity/opportunityService';

const OPPORTUNITY_CONTEXT = 'Opportunity';

const OpportunityContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getPermissions } = useOpportunityService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={OPPORTUNITY_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default OpportunityContext;
